import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=6afb08f4&scoped=true"
import script from "./StockOverview.vue?vue&type=script&lang=js"
export * from "./StockOverview.vue?vue&type=script&lang=js"
import style0 from "./StockOverview.vue?vue&type=style&index=0&id=6afb08f4&prod&scoped=true&lang=css"
import style1 from "./StockOverview.vue?vue&type=style&index=1&id=6afb08f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb08f4",
  null
  
)

export default component.exports